export default __webpack_public_path__ + "static/media/bonniernews.821d36de.jpg";